import PropTypes from "prop-types";
import { m } from "framer-motion";
import { Box as PolarisBox } from "@shopify/polaris";

import { varContainer } from "./variants";

MotionContainer.propTypes = {
  action: PropTypes.bool,
  animate: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default function MotionContainer({ animate, action = false, children, ...other }) {
  const MotionDiv = m.div;

  if (action) {
    return (
      <MotionDiv initial={false} animate={animate ? "animate" : "exit"} variants={varContainer()} {...other}>
        <PolarisBox>{children}</PolarisBox>
      </MotionDiv>
    );
  }

  return (
    <MotionDiv initial="initial" animate="animate" exit="exit" variants={varContainer()} {...other}>
      <PolarisBox>{children}</PolarisBox>
    </MotionDiv>
  );
}
